import { useFormik } from "formik";
import { useEffect, useState } from "react";
import * as Components from "../../../../components";
import { FormContainer } from "../../Shared";
import { useDropDownSearch, useForm } from "../../../../hooks";
import {
  useGetAppsQuery,
  useCreateApiKeyMutation,
  useUpdateApiKeyMutation,
  useGetApiKeyQuery,
  useGetRolesQuery,
} from "../../services";
import { ApiKeyValidation } from "../../validations";
import { mergeObjects } from "../../../../shared/helper";
import { getLocalizedString } from "../../../../shared/translation";

export const ApiKeyForm = ({ onClose, idToEdit }) => {
  const [initialValues, setInitialValues] = useState({
    name: "",
    note: "",
    client_app_role_id: "",
    is_enabled: true,
    client_app_id: "",
  });

  const formik = useFormik({
    initialValues,
    validationSchema: !idToEdit && ApiKeyValidation,
    enableReinitialize: true,
    onSubmit: (values) => handleFormSubmit(values),
  });

  const { data: datumApiKey = {} } = useGetApiKeyQuery({ id: idToEdit }, { skip: !idToEdit });

  //Get the list of applications
  const { data: apps = { data: [] }, isSuccess: isAppsSuccess } = useGetAppsQuery();

  // Get roles list
  const {
    data: rolesList,
    setSearchKey: setRolesSearch,
    isSuccess: isRolesSuccess,
  } = useDropDownSearch({
    useData: useGetRolesQuery,
    simpleSearchKey: "name_or_client_app_app_name_cont",
  });

  const { create: createApiKeys, update: updateApiKeys } = useForm({
    createMutation: useCreateApiKeyMutation,
    updateMutation: useUpdateApiKeyMutation,
    closeForm: onClose,
    setError: formik.setErrors,
  });

  useEffect(() => {
    if (idToEdit && datumApiKey) {
      setInitialValues(mergeObjects(initialValues, datumApiKey));
    }
  }, [datumApiKey]);

  const handleFormSubmit = (formData) => {
    if (idToEdit) {
      updateApiKeys({ id: idToEdit, formData });
    } else {
      createApiKeys({ formData });
    }
  };

  return (
    <>
      <FormContainer
        resourceName={getLocalizedString("api_key", "API Key")}
        handleFormSubmit={formik.handleSubmit}
        closeForm={() => onClose(false)}
        idToEdit={idToEdit}
      >
        <Components.QIInput
          label={getLocalizedString("name", "Name")}
          placeholder={getLocalizedString("enter_name", "Enter Name")}
          {...formik.getFieldProps("name")}
          error={formik?.touched?.name && formik?.errors?.name}
        />
        <Components.QIInput
          label={getLocalizedString("description", "Description")}
          placeholder={getLocalizedString("enter_description", "Enter Description")}
          {...formik.getFieldProps("note")}
          error={formik?.touched?.note && formik?.errors?.note}
        />
        <Components.QICustomSelect
          label={getLocalizedString("role", "Role")}
          value={formik.values.client_app_id + "," + formik.values.client_app_role_id}
          onChange={(value) => {
            formik.setFieldValue("client_app_role_id", value.substring(value.indexOf(",") + 1));
            formik.setFieldValue("client_app_id", value.substring(0, value.indexOf(",")));
            setRolesSearch("");
          }}
          onSearch={setRolesSearch}
          error={formik?.touched?.client_app_role_id && formik?.errors?.client_app_role_id}
          labelClassName="role"
          className="narrow-select-dropdown"
        >
          {apps?.data?.map((app) => {
            const name = app?.name;
            return rolesList?.data?.map((role, id) => {
              return (
                <li value={`${app?.id},${role?.id}`} key={id}>
                  {`${name}-${role?.name}`}
                </li>
              );
            });
          })}
        </Components.QICustomSelect>
        {idToEdit && (
          <Components.QISwitch
            label={getLocalizedString("active", "Active")}
            {...formik.getFieldProps("is_enabled")}
            error={formik.touched.is_enabled && formik.errors.is_enabled}
            onChange={() => {
              formik.setFieldValue("is_enabled", !formik.values.is_enabled);
            }}
          />
        )}
      </FormContainer>
    </>
  );
};
